import { render } from "./NotFound.vue?vue&type=template&id=0a71c448&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=0a71c448&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a71c448"]])

export default __exports__